import * as actionTypes from 'js/constants/actionTypes';

export const saveState = (path: string, value: any, newURL?: string) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SAVE_HASHED_STATE,
    payload: {
      path,
      value,
    },
  });
};

export const hydrateState = (hashedState: string) => (dispatch) => {
  return dispatch({
    type: actionTypes.HYDRATE_HASHED_STATE,
    payload: {
      hashedState,
    },
  });
};
